<template>
  <div>
    <usernav></usernav>
    <el-col>
      <el-card shadow="never" :body-style="{padding: '16px',textAlign: 'left'}">
        <div class="G-title">
          <span>修改资料</span>
        </div>
        <div style="max-width: 25rem;margin: 0 auto;padding: 1rem!important;">
        <el-form :label-position="labelPosition" :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item label="用户名">
            <el-input v-model="ruleForm.username" disabled=""></el-input>
          </el-form-item>
          <el-form-item prop="email" label="邮箱">
            <el-input v-model.trim="ruleForm.email" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="old_password" label="旧密码">
            <el-input v-model="ruleForm.old_password" autocomplete="off" show-password></el-input>
          </el-form-item>
          <el-form-item prop="new_password" label="新密码">
            <el-input v-model="ruleForm.new_password" autocomplete="off" show-password></el-input>
          </el-form-item>
          <el-form-item class="form-group">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="loading" style="width: 100%">确认修改
            </el-button>
          </el-form-item>
        </el-form>

        </div>
      </el-card>
    </el-col>
  </div>
</template>

<script>
import Usernav from '@/components/base/header/usernav'
import {request} from '../../network/request'
export default {
  name: 'editprofile',
  components: {Usernav},
  data () {
    var validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请正确填写邮箱'))
      } else {
        if (value !== '') {
          var reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
          if (!reg.test(value)) {
            callback(new Error('请输入有效的邮箱'))
          }
        }
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (!this.ruleForm.new_password) {
        callback()
      } else {
        if (value.length < 6 || value.length > 32 || /[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('旧密码 必须介于 6 - 32 个字符之间。'))
        }
        callback()
      }
    }
    var validatenewPass = (rule, value, callback) => {
      if (!this.ruleForm.old_password) {
        callback()
      } else {
        if (value.length < 6 || value.length > 32 || /[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error('新密码 必须介于 6 - 32 个字符之间。'))
        }
        callback()
      }
    }
    return {
      labelPosition: 'top',
      loading: false,
      ruleForm: {
        username: '',
        new_password: '',
        old_password: '',
        email: ''
      },
      rules: {
        new_password: [
          {validator: validatenewPass, trigger: 'blur'}
        ],
        old_password: [
          {validator: validatePass, trigger: 'blur'}
        ],
        email: [
          {validator: validateEmail, trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.getuser()
  },
  methods: {
    getuser () {
      request({
        url: '/api/editprofile',
        method: 'get'
      }).then(res => {
        this.ruleForm.username = res.data.username
        this.ruleForm.email = res.data.email
      }).catch(err => {
        this.$message.error('网络出错')
        this.tip = err
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          let data = new URLSearchParams()
          data.append('email', this.ruleForm.email)
          data.append('new_password', this.ruleForm.new_password)
          data.append('old_password', this.ruleForm.old_password)
          request({
            url: '/api/editprofile',
            method: 'post',
            data: data
          }).then(res => {
            if (res.data.status === 0) {
              this.$message.error('旧密码错误')
              this.loading = false
            }
            if (res.data.status === 1) {
              this.$message.success('更新成功')
              this.loading = false
            }
          }).catch(err => {
            this.$message.error('网络出错')
            this.loading = false
            console.log(err)
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .G-title {
    border-bottom: 1px solid #f2f2f2 !important;
    padding-bottom: 10px;
    justify-content: space-between !important;
    display: flex !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/user/editprofile.vue